import Image from "next/image";
import React from "react";
import styles from "./styles.module.scss";

interface Block {
  name: string;
  quote: string;
  position: string;
  description_two: string;
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Props {
  block: Block;
}
const ConnectBanner: React.FC<Props> = ({ block }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";
  const imgURL = block?.image?.data?.attributes?.url;
  return (
    <>
      <section className="author  pb-[56px] lg:pb-[80px] xl:pb-[100px] w-[90%] mx-auto lg:pl-[100px] xl:pl-[100px]">
        <div className="container">
          <div>
            <div className="bg-[#B0D9F7] p-[8px_31px] flex items-center lg:mb-[0px] mb-[167px] ">
              <p className="text-center md:text-left  text-[16px] font-regular w-full text-blue-900">
                {block?.position ?? ""}
              </p>
            </div>

            <div
              className={`${styles["author-content"]} relative z-[1] lg:p-[80px_80px_80px_75px]`}
            >
              <div className="mt-[-150px] lg:mt-0 author-img absolute top-0 left-1/2 -translate-x-1/2 lg:top-1/2 lg:left-[-20px] lg:-translate-y-1/2 ">
                <div className="p-[5px]  inline-block">
                  <Image
                    src={imgURL ? baseUrl + imgURL : "/images/author-img.png"}
                    alt="Author"
                    className="h-[180px] w-[180px] lg:object-cover object-contain"
                    width={180}
                    height={180}
                  />
                </div>
              </div>

              <div className="author-info p-[60px_20px] lg:p-[0] lg:pl-[24px] relative z-10">
                <h6 className="font-bold text-primary-text text-[24px] mb-[24px] lg:text-left text-center">
                  {block?.name ?? ""}
                </h6>
                <h4 className="text-heading-5 font-bold text-primary-text lg:text-left text-center">
                  {block?.quote ?? ""}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConnectBanner;
